import React, { useState } from "react";
import { Avatar } from "antd";
import { useSecureImage } from "./AuthenticatedImage";
import { previewOnClick } from "./ImagePreview";
import { getImgUrl } from "./UserProfile..jsx";

// antd Avatar for a profile picture stored under /public/ (served only through the secure endpoint):
// the picture is loaded with the login token, its initials show until then (or without a picture), and a
// click opens the picture in the app's viewer (a zoom icon on hover). `image`: the picture's address;
// `preview={false}` to turn the viewer off.
const SecureAvatar = ({ image, preview = true, className, children, ...props }) => {
  const url = useSecureImage(image || null);
  const clickable = preview && !!image && !!url;
  return (
    <Avatar
      {...props}
      className={[className, clickable && "planit-zoom"].filter(Boolean).join(" ") || undefined}
      src={url || undefined}
      {...(clickable ? previewOnClick(image) : {})}
    >
      {children}
    </Avatar>
  );
};

// An initials badge that keeps its own look (a span with its class's size and colour, e.g. the meetings'
// .av) and shows the person's picture over the initials once it has loaded, with the zoom icon and the
// viewer like the avatars. `image`: a stored file name or an address; `preview={false}` in pickers, where a
// click picks the person.
export const PictureBadge = ({ as: Tag = "span", image, preview = true, className = "", style, children }) => {
  const src = getImgUrl(image);
  const url = useSecureImage(src);
  const [loadedUrl, setLoadedUrl] = useState(null);
  const zoom = preview && !!url && loadedUrl === url;
  return (
    <Tag
      className={`${className}${zoom ? " planit-zoom" : ""}`.trim() || undefined}
      style={url ? { ...style, position: "relative", overflow: "hidden" } : style}
      {...(zoom ? previewOnClick(src) : {})}
    >
      {children}
      {url && (
        <img
          key={url}
          src={url}
          alt=""
          onLoad={() => setLoadedUrl(url)}
          onError={(e) => { e.currentTarget.style.display = "none"; }}
          style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit" }}
        />
      )}
    </Tag>
  );
};

export default SecureAvatar;
